// React
import React, { FC } from "react";

// Dashboards
import { YourEDUVSNetwork } from "Containers/GoodData/dashboards";

const EduVsNetwork: FC<any> = props => {
  return <YourEDUVSNetwork />;
};

export default EduVsNetwork;
try {
    // @ts-ignore
    EduVsNetwork.displayName = "EduVsNetwork";
    // @ts-ignore
    EduVsNetwork.__docgenInfo = { "description": "", "displayName": "EduVsNetwork", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/pages/Analytics/EduVsNetwork/EduVsNetwork.tsx#EduVsNetwork"] = { docgenInfo: EduVsNetwork.__docgenInfo, name: "EduVsNetwork", path: "src/pages/Analytics/EduVsNetwork/EduVsNetwork.tsx#EduVsNetwork" };
}
catch (__react_docgen_typescript_loader_error) { }